<template>
  <div v-if="!hidden" class="flex h-full items-center gap-1.5 px-2.5 text-[10px] text-amber-900">
    <span>left to plan</span>
    <b class="ml-auto text-[11px] font-bold text-amber-950">{{ total.toLocaleString() }}</b>
    <i v-if="unknownCount > 0" class="text-[9px] italic text-amber-700">+{{ unknownCount }} unknown</i>
  </div>
</template>

<script setup lang="ts">
  defineProps<{ total: number; unknownCount: number; hidden: boolean }>();
</script>
